import { useTheme } from '@/contexts/ThemeContext';

const LOGO_VARIANT_A = 'https://customer-assets.emergentagent.com/job_property-vendor-hub/artifacts/7qvqg3yv_Brand%20Logo%20Variant%20A.PNG';
const LOGO_VARIANT_B = 'https://customer-assets.emergentagent.com/job_property-vendor-hub/artifacts/w13j79st_Brand%20Logo%20Variant%20B.PNG';

/*
 * Logo images are 2000x2000px with the brand text centered.
 * We render them at a fixed width and let CSS crop to the text region
 * using object-fit/object-position for crisp, artifact-free rendering.
 */

const LogoImg = ({ src, width, testId }) => (
  <img
    src={src}
    alt="VendorSuite"
    data-testid={testId}
    style={{
      width,
      height: Math.round(width * 0.15),
      objectFit: 'cover',
      objectPosition: '50% 54.5%',
      display: 'block',
      imageRendering: 'auto',
    }}
  />
);

// Theme-aware: Variant A on dark, Variant B on light
export const BrandLogo = ({ className = '', width = 160 }) => {
  const { theme } = useTheme();
  const src = theme === 'dark' ? LOGO_VARIANT_A : LOGO_VARIANT_B;
  return <div className={`shrink-0 ${className}`}><LogoImg src={src} width={width} testId="brand-logo" /></div>;
};

// Fixed dark background → always Variant A
export const BrandLogoDark = ({ className = '', width = 160 }) => (
  <div className={`shrink-0 ${className}`}><LogoImg src={LOGO_VARIANT_A} width={width} /></div>
);

// Fixed light background → always Variant B
export const BrandLogoLight = ({ className = '', width = 160 }) => (
  <div className={`shrink-0 ${className}`}><LogoImg src={LOGO_VARIANT_B} width={width} /></div>
);
